<template>
  <div class="brand-activity">
    <BackToTop />
    <div class="container">
      <div class="box" v-if="topNews.content">
        <div class="box_left" v-html="topNews.content"></div>
        <div class="box_right">
          <img :src="topNews.cover_img" alt="" />
        </div>
      </div>
      <div v-else class="box-placeholder"></div>
      <!-- 中品资讯 -->
      <div class="module">
        <ModuleHeader
          chinese-title="中品资讯"
          english-title="ACTIVITY SCHEDULE"
        />
        <BannerCarousel :banners="carouselList" :topNewsList="topNewsList" />
        <div class="mokuai">
          <div class="mokuai_left">
            <div class="mokuai_item mokuai_item_full">
              <a v-if="bannerListData[0]" :href="bannerListData[0].url || 'javascript:;'" target="_blank">
                <img :src="bannerListData[0].img" alt="" />
              </a>
            </div>
            <div class="mokuai_row">
              <div class="mokuai_item mokuai_item_half">
                <a v-if="bannerListData[1]" :href="bannerListData[1].url || 'javascript:;'" target="_blank">
                  <img :src="bannerListData[1].img" alt="" />
                </a>
              </div>
              <div class="mokuai_item mokuai_item_half">
                <a v-if="bannerListData[2]" :href="bannerListData[2].url || 'javascript:;'" target="_blank">
                  <img :src="bannerListData[2].img" alt="" />
                </a>
              </div>
            </div>
          </div>
          <div class="mokuai_right">
            <a v-if="bannerListData[3]" :href="bannerListData[3].url || 'javascript:;'" target="_blank">
              <img :src="bannerListData[3].img" alt="" />
            </a>
          </div>
        </div>
        <div class="module_news">
          <div class="module_news_left" :class="{ 'has-border': newsList.length > 10 }">
            <span
              v-for="(item, index) in newsList.slice(0, 10)"
              :key="'left-' + index"
              :class="item.is_bold ? 'news1' : 'news2'"
              @click="goToDetail(item.id)"
            >{{ item.title }}</span>
          </div>
          <div class="module_news_right" v-if="newsList.length > 10">
            <span
              v-for="(item, index) in newsList.slice(10)"
              :key="'right-' + index"
              :class="item.is_bold ? 'news1' : 'news2'"
              @click="goToDetail(item.id)"
            >{{ item.title }}</span>
          </div>
        </div>
      </div>
      <!-- 中国品牌日 -->
      <div class="module">
        <ModuleHeader
          chinese-title="中国品牌日"
          english-title="CHARACTER INTERVIEW"
        />
        <div class="module_banner">
          <div class="module_banner_carousel">
            <div
              class="module_banner_slide"
              v-for="(item, index) in brandDayBanners"
              :key="index"
              :class="{ active: index === brandDayBannerIndex }"
              @click="item.url && openLink(item.url)"
              :style="item.url ? 'cursor:pointer' : ''"
            >
              <img :src="item.img" alt="" />
            </div>

            <div
              class="module_banner_arrow module_banner_arrow_left"
              @click="prevBrandDayBanner"
            >
              <img :src="wLeftIcon" alt="上一张" />
            </div>
            <div
              class="module_banner_arrow module_banner_arrow_right"
              @click="nextBrandDayBanner"
            >
              <img :src="wRightIcon" alt="下一张" />
            </div>
          </div>

          <div class="module_banner_thumbs">
            <div
              class="module_banner_thumb"
              v-for="(item, index) in brandDayThumbs"
              :key="index"
              @click="item.url && openLink(item.url)"
              :style="item.url ? 'cursor:pointer' : ''"
            >
              <img :src="item.img" alt="" />
            </div>
          </div>
        </div>
      </div>
      <!-- 往年回顾 -->
      <div class="module">
        <ModuleHeader
          chinese-title="往年回顾"
          english-title="REVIEW OF PREVIOUS YEARS"
        />
        <div class="review_images">
          <div
            class="review_image_item"
            v-for="(item, index) in reviewImages"
            :key="index"
            @click="item.url && openLink(item.url)"
            :style="item.url ? 'cursor:pointer' : ''"
          >
            <img :src="item.img" alt="" />
          </div>
        </div>
      </div>
      <!-- 世界品牌路 -->
      <div class="module">
        <ModuleHeader
          chinese-title="世界品牌路"
          english-title="PARTY PICTURES"
        />
        <div class="module_banner world_brand_banner">
          <div class="module_banner_carousel world_brand_carousel">
            <div
              class="module_banner_slide"
              v-for="(item, index) in worldBrandBanners"
              :key="index"
              :class="{ active: index === worldBrandBannerIndex }"
              @click="item.url && openLink(item.url)"
              :style="item.url ? 'cursor:pointer' : ''"
            >
              <img :src="item.img" alt="" />
              <div class="banner-mask">
                <span class="banner-news">{{ item.title }}</span>
              </div>
            </div>

            <div
              class="module_banner_arrow module_banner_arrow_left"
              @click="prevWorldBrandBanner"
            >
              <img :src="wLeftIcon" alt="上一张" />
            </div>
            <div
              class="module_banner_arrow module_banner_arrow_right"
              @click="nextWorldBrandBanner"
            >
              <img :src="wRightIcon" alt="下一张" />
            </div>
          </div>

          <div class="module_banner_thumbs world_brand_thumbs">
            <div
              class="module_banner_thumb world_brand_thumb"
              v-for="(item, index) in worldBrandThumbs"
              :key="index"
              @click="item.url && openLink(item.url)"
              :style="item.url ? 'cursor:pointer' : ''"
            >
              <img :src="item.img" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackToTop from "../components/BackToTop.vue";
import BannerCarousel from "../components/BannerCarousel.vue";
import ModuleHeader from "../components/ModuleHeader.vue";
import WleftIcon from "../assets/Wleft_icon.png";
import WrightIcon from "../assets/Wright_icon.png";
import { getTrendDetailHeader } from "@/api";

import { imgBaseURL } from "@/api/index";

export default {
  name: "BrandActivity",
  components: {
    BannerCarousel,
    BackToTop,
    ModuleHeader,
  },
  data() {
    return {
      wLeftIcon: WleftIcon,
      wRightIcon: WrightIcon,
      // 顶部热点
      topNews: {
        id: null,
        cover_img: "",
        content: "",
      },
      brandDayBannerIndex: 0,
      brandDayBanners: [], // { img, url }
      brandDayThumbs: [], // { img, url }
      worldBrandBannerIndex: 0,
      worldBrandBanners: [], // { img, url, title }
      worldBrandThumbs: [], // { img, url }
      reviewImages: [], // { img, url }
      // 中品资讯
      banners: [],
      bannerListData: [], // 存储 banner 数据包括 url
      carouselList: [],
      newsList: [],
      topNewsList: [],
    };
  },
  mounted() {
    this.fetchTrendDetail();
  },
  methods: {
    async fetchTrendDetail() {
      try {
        const res = await getTrendDetailHeader(8);
        if (res.code === 1 && res.data) {
          const data = res.data;
          // top_news
          if (data.top_news) {
            this.topNews = {
              id: data.top_news.id,
              cover_img: imgBaseURL + data.top_news.cover_img,
              content: data.top_news.content,
            };
          }
          // 中国品牌日 pin_pai_ri
          if (data.pin_pai_ri) {
            // carousel_list 轮播图
            if (data.pin_pai_ri.carousel_list) {
              this.brandDayBanners = data.pin_pai_ri.carousel_list.map(
                (item) => ({
                  img: imgBaseURL + item.img,
                  url: item.url || null,
                })
              );
            }
            // banner_list 下面四张图
            if (data.pin_pai_ri.banner_list) {
              this.brandDayThumbs = data.pin_pai_ri.banner_list.map(
                (item) => ({
                  img: imgBaseURL + item.img,
                  url: item.url || null,
                })
              );
            }
          }
          // 往年回顾 hui_gu
          if (data.hui_gu && data.hui_gu.banner_list) {
            this.reviewImages = data.hui_gu.banner_list.map(
              (item) => ({
                img: imgBaseURL + item.img,
                url: item.url || null,
              })
            );
          }
          // 世界品牌路 pin_pai_lu
          if (data.pin_pai_lu) {
            // carousel_list 轮播图
            if (data.pin_pai_lu.carousel_list) {
              this.worldBrandBanners = data.pin_pai_lu.carousel_list.map(
                (item) => ({
                  img: imgBaseURL + item.img,
                  url: item.url || null,
                  title: item.title || "",
                })
              );
            }
            // banner_list 下面六张图
            if (data.pin_pai_lu.banner_list) {
              this.worldBrandThumbs = data.pin_pai_lu.banner_list.map(
                (item) => ({
                  img: imgBaseURL + item.img,
                  url: item.url || null,
                })
              );
            }
          }
          // 中品资讯 zi_xun
          if (data.zi_xun) {
            const ziXun = data.zi_xun;
            // banner_list 四张图片
            if (ziXun.banner_list) {
              this.banners = ziXun.banner_list.map(
                (item) => imgBaseURL + item.img
              );
              this.bannerListData = ziXun.banner_list.map(
                (item) => ({
                  img: imgBaseURL + item.img,
                  url: item.url || null,
                })
              );
            }
            // carousel_list 轮播内容 - 传给 BannerCarousel 的 banners
            if (ziXun.carousel_list) {
              console.log('API 返回的 carousel_list 数据:', JSON.parse(JSON.stringify(ziXun.carousel_list)));
              this.carouselList = ziXun.carousel_list.map((item) => ({
                img: imgBaseURL + item.cover_img,
                title: item.title,
                title_en: item.title_en,
                id: item.id,
                url: item.url || null,
              }));
              console.log('处理后的 carouselList 数据:', JSON.parse(JSON.stringify(this.carouselList)));
            }
            // news_list 新闻列表
            if (ziXun.news_list) {
              this.newsList = ziXun.news_list.map((item) => ({
                id: item.id,
                title: item.title,
                title_en: item.title_en,
                is_bold: item.is_bold,
              }));
            }
            // top_news_list 置顶新闻
            if (ziXun.top_news_list) {
              this.topNewsList = ziXun.top_news_list.map((item) => ({
                id: item.id,
                title: item.title,
                title_en: item.title_en,
                is_bold: item.is_bold,
              }));
            }
          }
        }
      } catch (error) {
        console.error("获取中品动态数据失败:", error);
      }
    },
    goToDetail(id) {
      if (id != null && id !== undefined && id !== "") {
        window.open(this.$router.resolve({ name: "NewsDetail", params: { id } }).href, '_blank');
      }
    },
    openLink(url) {
      if (url) {
        window.open(url, '_blank');
      }
    },
    nextBrandDayBanner() {
      this.brandDayBannerIndex =
        (this.brandDayBannerIndex + 1) % this.brandDayBanners.length;
    },
    prevBrandDayBanner() {
      this.brandDayBannerIndex =
        (this.brandDayBannerIndex - 1 + this.brandDayBanners.length) %
        this.brandDayBanners.length;
    },
    nextWorldBrandBanner() {
      this.worldBrandBannerIndex =
        (this.worldBrandBannerIndex + 1) % this.worldBrandBanners.length;
    },
    prevWorldBrandBanner() {
      this.worldBrandBannerIndex =
        (this.worldBrandBannerIndex - 1 + this.worldBrandBanners.length) %
        this.worldBrandBanners.length;
    },
  },
};
</script>

<style scoped lang="scss">
.brand-activity {
  width: 100%;
}

.container {
  max-width: 76rem;
  margin: 0 auto;
}
.box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 320px;
  min-height: 320px;
  margin: 90px 0;
}
.box-placeholder {
  height: 320px;
  min-height: 320px;
  margin: 90px 0;
}
.box {
  .box_left {
    width: 60%;
    height: 100%;
    font-family: MicrosoftYaHei;
    font-size: 16px;
    color: #282728;
    text-align: justify;
    text-indent: 2em;
  }
  .box_right {
    width: 37%;
    height: 100%;
    overflow: hidden;
    img {
      width: 100%;
      transition: transform 0.3s ease, filter 0.3s ease;
      &:hover {
        transform: scale(1.05);
        filter: brightness(1.1);
      }
    }
  }
}
.module {
  width: 100%;
  .module_banner {
    width: 100%;
    margin: 80px 0 140px 0;
  }
  .module_banner_carousel {
    width: 100%;
    height: 380px;
    position: relative;
    overflow: hidden;
  }
  .module_banner_slide {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 0.5s ease;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
  .module_banner_slide.active {
    opacity: 1;
  }
  .module_banner_arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    img {
      width: 27px;
      height: 51px;
      display: block;
    }
  }
  .module_banner_arrow_left {
    left: 120px;
  }
  .module_banner_arrow_right {
    right: 120px;
  }
  .module_banner_thumbs {
    width: 100%;
    display: flex;
    gap: 12px;
    margin-top: 12px;
  }
  .module_banner_thumb {
    width: calc((100% - 36px) / 4);
    height: 180px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      transition: transform 0.3s ease, filter 0.3s ease;
      &:hover {
        transform: scale(1.05);
        filter: brightness(1.1);
      }
    }
  }
  // 世界品牌路模块特殊样式
  .world_brand_banner {
    .world_brand_carousel {
      height: 485px;
      .module_banner_slide {
        .banner-mask {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          box-sizing: border-box;
          padding: 10px 16px;
          background: rgba(0, 0, 0, 0.6);
          .banner-news {
            font-family: MicrosoftYaHei;
            font-size: 16px;
            color: #ffffff;
            text-align: center;
            display: block;
          }
        }
      }
    }
    .world_brand_thumbs {
      .world_brand_thumb {
        width: calc((100% - 60px) / 6);
        height: 396px;
      }
    }
  }
  .review_images {
    width: 100%;
    display: flex;
    gap: 7px;
    margin: 80px 0 140px 0;
    .review_image_item {
      flex: 1;
      height: 430px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        transition: transform 0.3s ease, filter 0.3s ease;
        &:hover {
          transform: scale(1.05);
          filter: brightness(1.1);
        }
      }
    }
  }
  .mokuai {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 323px;
    .mokuai_left {
      width: 48%;
      height: 100%;
      display: flex;
      flex-direction: column;
      gap: 13px;
      .mokuai_item {
        background: #d7d7d7;
        border: 1px solid #ebebeb;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease, filter 0.3s ease;
          &:hover {
            transform: scale(1.05);
            filter: brightness(1.1);
          }
        }
      }
      .mokuai_item_full {
        width: 100%;
        height: 155px;
      }
      .mokuai_row {
        display: flex;
        gap: 13px;
        width: 100%;
        .mokuai_item_half {
          flex: 1;
          height: 155px;
        }
      }
    }
    .mokuai_right {
      width: 48%;
      height: 100%;
      background: #d7d7d7;
      border: 1px solid #ebebeb;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s ease, filter 0.3s ease;
        &:hover {
          transform: scale(1.05);
          filter: brightness(1.1);
        }
      }
    }
  }
  .module_news {
    display: flex;
    width: 100%;
    margin: 88px 0;
    .module_news_left,
    .module_news_right {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 10px;
      span {
        width: 100%;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .news1 {
        font-family: MicrosoftYaHei;
        font-size: 16px;
        color: #424242;
        cursor: pointer;
      }
      .news2 {
        font-family: MicrosoftYaHei;
        font-size: 16px;
        color: #424242;
        font-weight: bold;
        cursor: pointer;
      }
    }
    .module_news_left {
      &.has-border {
        border-right: 1px solid #bfbfbf;
        padding-right: 20px;
      }
    }
    .module_news_right {
      padding-left: 20px;
    }
  }
}

// 平板端响应式 (768px - 1024px)
@media screen and (max-width: 1024px) and (min-width: 768px) {
  .container {
    padding: 0 20px;
  }

  .box {
    flex-direction: column;
    height: auto;
    margin: 60px 0;
    gap: 20px;

    .box_left {
      width: 100%;
      font-size: 15px;
      line-height: 1.8;
    }

    .box_right {
      width: 100%;
      height: auto;
    }
  }

  .module {
    .module_banner {
      margin: 60px 0 100px 0;

      .module_banner_carousel {
        height: 300px;
      }

      .module_banner_arrow_left {
        left: 30px;
      }

      .module_banner_arrow_right {
        right: 30px;
      }

      .module_banner_arrow img {
        width: 20px;
        height: 38px;
      }

      .module_banner_thumbs {
        gap: 10px;
        margin-top: 10px;
      }

      .module_banner_thumb {
        width: calc((100% - 30px) / 4);
        height: 140px;
      }
    }

    .world_brand_banner {
      .world_brand_carousel {
        height: 380px;

        .banner-mask {
          padding: 8px 12px;

          .banner-news {
            font-size: 15px;
          }
        }
      }

      .world_brand_thumbs {
        .world_brand_thumb {
          width: calc((100% - 50px) / 6);
          height: 300px;
        }
      }
    }

    .review_images {
      margin: 60px 0 100px 0;
      gap: 6px;

      .review_image_item {
        height: 320px;
      }
    }

    .mokuai {
      flex-direction: column;
      height: auto;
      gap: 13px;

      .mokuai_left {
        width: 100%;
      }

      .mokuai_right {
        width: 100%;
        height: 200px;
      }
    }

    .module_news {
      flex-direction: column;
      margin: 60px 0;
      gap: 20px;

      .module_news_left,
      .module_news_right {
        width: 100%;
      }

      .module_news_left {
        &.has-border {
          border-right: none;
          border-bottom: 1px solid #bfbfbf;
        }
        padding-right: 0;
        padding-bottom: 20px;
      }

      .module_news_right {
        padding-left: 0;
        padding-top: 20px;
      }

      .news1,
      .news2 {
        font-size: 15px;
      }
    }
  }
}

// 移动端响应式 (< 768px)
@media screen and (max-width: 767px) {
  .container {
    padding: 0 15px;
  }

  .box {
    flex-direction: column;
    height: auto;
    margin: 40px 0;
    gap: 15px;

    .box_left {
      width: 100%;
      font-size: 14px;
      line-height: 1.7;
    }

    .box_right {
      width: 100%;
      height: auto;
    }
  }

  .module {
    .module_banner {
      margin: 40px 0 60px 0;

      .module_banner_carousel {
        height: 220px;
      }

      .module_banner_arrow_left {
        left: 10px;
      }

      .module_banner_arrow_right {
        right: 10px;
      }

      .module_banner_arrow img {
        width: 16px;
        height: 30px;
      }

      .module_banner_thumbs {
        gap: 8px;
        margin-top: 8px;
        flex-wrap: wrap;
      }

      .module_banner_thumb {
        width: calc((100% - 16px) / 2);
        height: 100px;

        &:nth-child(n + 3) {
          display: none;
        }
      }
    }

    .world_brand_banner {
      .module_banner_thumbs {
        flex-wrap: nowrap;

        .module_banner_thumb {
          &:nth-child(n + 3) {
            display: block;
          }
        }
      }
      .world_brand_carousel {
        height: 280px;

        .banner-mask {
          padding: 6px 10px;

          .banner-news {
            font-size: 13px;
            line-height: 1.5;
          }
        }
      }

      .world_brand_thumbs {
        display: flex;
        flex-wrap: nowrap;
        gap: 6px;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;
        -ms-overflow-style: none;
        width: 100%;
        padding-bottom: 5px;

        &::-webkit-scrollbar {
          display: none;
        }

        .world_brand_thumb {
          width: 120px;
          min-width: 120px;
          height: 200px;
          flex-shrink: 0;
        }
      }
    }

    .review_images {
      flex-direction: column;
      margin: 40px 0 60px 0;
      gap: 10px;

      .review_image_item {
        width: 100%;
        height: 250px;
      }
    }

    .mokuai {
      flex-direction: column;
      height: auto;
      gap: 10px;

      .mokuai_left {
        width: 100%;

        .mokuai_item_full {
          height: 120px;
        }

        .mokuai_row {
          gap: 10px;

          .mokuai_item_half {
            height: 120px;
          }
        }
      }

      .mokuai_right {
        width: 100%;
        height: 150px;
      }
    }

    .module_news {
      flex-direction: column;
      margin: 40px 0;
      gap: 15px;

      .module_news_left,
      .module_news_right {
        width: 100%;
      }

      .module_news_left {
        &.has-border {
          border-right: none;
          border-bottom: 1px solid #bfbfbf;
        }
        padding-right: 0;
        padding-bottom: 15px;
      }

      .module_news_right {
        padding-left: 0;
        padding-top: 15px;
      }

      .news1,
      .news2 {
        font-size: 14px;
      }
    }
  }
}
</style>
